import { Activity, CheckCircle2, Clock } from 'lucide-react';
import { ExpandableSection } from '@/components/expandable-section';

interface ActionItem {
  title: string;
  description?: string;
  status?: 'pending' | 'running' | 'done';
}

interface ActionBlockProps {
  title: string;
  items: ActionItem[];
  defaultExpanded?: boolean;
}

export function ActionBlock({ title, items, defaultExpanded = false }: ActionBlockProps) {
  return (
    <ExpandableSection
      title={title}
      icon={<Activity size={14} />}
      defaultExpanded={defaultExpanded}
      variant="subtle"
    >
      <div className="space-y-2">
        {items.map((item, idx) => (
          <div key={idx} className="flex items-start gap-2">
            <div className="mt-0.5">
              {item.status === 'done' && <CheckCircle2 size={12} className="text-green-500" />}
              {item.status === 'running' && <Clock size={12} className="animate-spin text-blue-500" />}
              {item.status === 'pending' && <Clock size={12} className="text-muted-foreground" />}
              {!item.status && <span className="text-muted-foreground">•</span>}
            </div>
            <div className="flex-1">
              <p className="text-xs text-foreground">{item.title}</p>
              {item.description && (
                <p className="mt-0.5 text-[11px] text-muted-foreground">{item.description}</p>
              )}
            </div>
          </div>
        ))}
      </div>
    </ExpandableSection>
  );
}
